// extracted by mini-css-extract-plugin
module.exports = {"dots-wrapper":"DotsDropdown_dots-wrapper__1278A","dots-icon":"DotsDropdown_dots-icon__1yDCF","rotated":"DotsDropdown_rotated__2VSN5"};